var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStoreonLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170 151",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FF003D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FFC300"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M34 21h110v90H34z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    width: "141.9%",
    height: "147.5%",
    x: "-21%",
    y: "-23.7%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 10
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "38.563%",
    x2: "13.356%",
    y1: "45.072%",
    y2: "96.122%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FCF53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#F8A21C"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15.557 142.715c0-2.397-13.865-1.786-13.865-10.105 0-4.7 3.901-7.567 10.528-7.567 4.653 0 8.601 2.162 10.152 4.418l-4.653 4.465c-1.598-1.645-3.807-2.538-6.862-2.538-1.269 0-2.115.282-2.115 1.175 0 2.115 13.865 1.457 13.865 10.105 0 5.358-4.794 7.708-10.34 7.708-5.969 0-9.964-2.726-11.703-5.922l5.405-3.666c1.316 1.692 4.042 3.243 7.05 3.243 1.645 0 2.538-.423 2.538-1.316zm7.99-10.81v-6.345H28.2v-5.687h6.815v5.687h7.473v6.345h-7.473v7.943c0 2.961.658 4.089 2.491 4.089 1.598 0 2.867-.564 4.183-1.598l2.82 4.841c-1.692 1.786-4.324 3.102-7.661 3.102-5.123 0-8.648-2.773-8.648-8.413v-9.964h-4.653zm21.667 5.828c0-7.379 5.405-12.69 13.207-12.69 7.802 0 13.301 5.311 13.301 12.69 0 7.332-5.499 12.643-13.301 12.643-7.567 0-13.207-5.311-13.207-12.643zm7.05 0c0 3.572 2.491 6.298 6.157 6.298 3.713 0 6.251-2.35 6.251-6.298 0-4.042-2.82-6.345-6.251-6.345-3.431 0-6.157 2.303-6.157 6.345zM74.777 150v-24.44h6.815v.987c.517-.705 2.162-1.457 3.76-1.457 2.585 0 3.713.752 4.794 2.115l-3.478 5.452c-.329-.611-1.316-.987-2.209-.987-1.081 0-2.303.47-2.867 2.538V150h-6.815zm35.485-8.648l4.089 4.136c-2.632 3.29-6.439 4.888-10.528 4.888-7.896 0-13.207-4.935-13.207-12.643 0-7.144 4.418-12.69 12.69-12.69 6.674 0 11.656 4.418 11.656 11.233 0 .752-.094 2.115-.376 3.948H97.76c.658 2.679 3.149 3.807 6.157 3.807 2.303 0 4.888-.893 6.345-2.679zm-7.191-10.199c-2.585 0-4.324 1.034-5.17 3.196h10.011c-.611-2.303-2.35-3.196-4.841-3.196zm13.771 6.58c0-7.379 5.405-12.69 13.207-12.69 7.802 0 13.301 5.311 13.301 12.69 0 7.332-5.499 12.643-13.301 12.643-7.567 0-13.207-5.311-13.207-12.643zm7.05 0c0 3.572 2.491 6.298 6.157 6.298 3.713 0 6.251-2.35 6.251-6.298 0-4.042-2.82-6.345-6.251-6.345-3.431 0-6.157 2.303-6.157 6.345zM146.405 150v-24.44h6.815v1.739c1.081-1.316 3.384-2.209 6.674-2.209 6.251 0 9.635 3.337 9.635 11.186V150h-6.815v-13.301c0-3.948-1.551-5.264-4.794-5.264-2.209 0-3.854 1.175-4.7 3.243V150h-6.815z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M45 111C22.909 111 5 93.091 5 71s17.909-40 40-40c.245 0 .49.002.734.007C53.21 12.812 71.109 0 92 0c27.614 0 50 22.386 50 50 0 .79-.018 1.575-.055 2.356C154.145 56.162 163 67.547 163 81c0 16.569-13.431 30-30 30H45z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#800",
    fillOpacity: 0.5,
    filter: "url(#c)",
    mask: "url(#d)",
    d: "M74 45h39L91 82h26l-44.711 46.947 91.034.109L165.096 8l2.965 126.349H25l39.247-5.293L77 101H54z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M74 40h39L91 77h26l-60 63 20-44H54z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStoreonLogo);
export default __webpack_public_path__ + "static/media/storeonLogo.6d136c65ac5aa34aa987524a9bccbbdb.svg";
export { ForwardRef as ReactComponent };